import { Stack, Typography } from "@mui/material";
import ProspectSuspectList from "../../components/customer-list/ProspectSuspectList";

const ProspectSuspectPage = () => {
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2} mb={1}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: "primary.main",
            fontWeight: 700,
            fontSize: { xs: "1.6rem", sm: "2.2rem" },
            letterSpacing: 0.5,
            flexGrow: 1,
          }}
        >
          Prospekt/Suspekt
        </Typography>
      </Stack>
      <ProspectSuspectList />
    </>
  );
};

export default ProspectSuspectPage;
